import styled from 'styled-components';
import { motion } from 'framer-motion';
import type { Target, Transition } from 'framer-motion';
import colours from 'theme/atoms/colours';
import breakpoints from 'theme/atoms/breakpoints';

const enterTransition: Transition = {
  duration: 0.3,
  ease: [0.16, 1, 0.3, 1],
};

const exitTransition: Transition = {
  duration: 0.2,
  ease: [0.4, 0, 0.2, 1],
};

export const menuButtonMotion = {
  initial: { scale: 0.15, opacity: 0 } satisfies Target,
  animate: { scale: 1, opacity: 1, transition: enterTransition },
  exit: { scale: 0.15, opacity: 0, transition: exitTransition },
};

export const MenuWrapper = styled('div')`
  position: relative;
  display: flex;
  align-items: flex-start;
  justify-content: flex-end;
  min-width: 50px;
  height: 50px;
`;

export const AnimatedMenuButton = styled(motion.div)<{
  disabled?: boolean;
  $selected?: boolean;
  $primary?: boolean;
}>`
  position: absolute;
  top: 0;
  right: 0;
  align-items: center;
  background-color: ${(props) => {
    if (props.$primary) return colours.primary[500];
    if (props.$selected) return 'black';
    return colours.neutral[200];
  }};
  border-radius: ${(props) => (props.$primary ? '100px' : '50%')};
  cursor: ${(props) => (props.disabled ? 'not-allowed' : 'pointer')};
  display: flex;
  height: 50px;
  justify-content: center;
  width: ${(props) => (props.$primary ? 'auto' : '50px')};
  padding: ${(props) => (props.$primary ? '0 20px' : '0')};
  gap: ${(props) => (props.$primary ? '8px' : '0')};
  transition: background-color 0.2s ease;
  transform-origin: top right;
  opacity: ${(props) => (props.disabled ? 0.5 : 1)};
  white-space: nowrap;

  &:hover:not([disabled]) {
    background-color: ${(props) => {
      if (props.$primary) return colours.primary[700];
      if (props.$selected) return colours.neutral[800];
      return colours.neutral[300];
    }};
  }

  &:active:not([disabled]) {
    background-color: ${(props) => {
      if (props.$primary) return colours.primary[800];
      if (props.$selected) return colours.neutral[700];
      return colours.neutral[400];
    }};
  }

  svg {
    color: ${(props) => {
      if (props.$primary) return 'white';
      if (props.$selected) return 'white';
      return 'black';
    }};
    flex-shrink: 0;
  }

  p {
    color: ${(props) => (props.$primary ? 'white' : 'inherit')};
    margin: 0;
  }

  @media (max-width: ${breakpoints.laptop}) {
    ${(props) =>
      props.$primary &&
      `
      width: 50px;
      padding: 0;
      border-radius: 50%;
      gap: 0;

      p {
        display: none;
      }
    `}
  }
`;
